export const initArray = <T = any>(arrs: T[] | undefined) => {
  if (Array.isArray(arrs)) {
    return arrs;
  }
  return [];
};

export const camelcase = require('camelcase');

export const pascalCase = (str: string) => {
  return camelcase(str, { pascalCase: true });
};
